import React from 'react';

require('./stylesheets/ContactComponent.scss');

const ContactComponent = (props) => {
  return (
    <div>
      <h2 className="center-text">Contact.</h2>
      <div className="row">
        <ul className="social-media">
          <li className="sm-property twitter"><a href="https://twitter.com/nathankleekamp/">Twitter</a></li>
          <li className="sm-property github"><a href="https://github.com/nathankleekamp/">GitHub</a></li>
          <li className="sm-property linkedin"><a href="https://www.linkedin.com/in/nathankleekamp/">LinkedIn</a></li>
        </ul>
      </div>
    </div>
  );
};

export default ContactComponent;



// WEBPACK FOOTER //
// ./app/src/Contact/components/ContactComponent.js